import { combineReducers } from "redux";
import navigation from "./navigation.reducer";
import settings from "./settings.reducer";
import navbar from "./navbar.reducer";
import routes from "./routes.reducer";

const fuseReducers = combineReducers({
  navigation,
  settings,
  navbar,
  routes,
});

export default fuseReducers;
